// extracted by mini-css-extract-plugin
module.exports = {"popup":"popup___2RUsS","wrap":"wrap___2e21J","header":"header___nW_hh","title":"title___18qS5","list":"list___1W1ny","tip":"tip___1rm0o"};